import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import RequisitionsPage from "@/pages/admin/RequisitionsPage";

export const Route = createFileRoute("/_admin/admin/requisitions/")({
  head: () => pageHead("Admin · Requisitions", "AKIVA admin · requisitions portal.", "/admin/requisitions", true),
  component: RequisitionsPage,
});
